import { render, staticRenderFns } from "./detail.dialog.vue?vue&type=template&id=5f3c9cba&scoped=true"
import script from "./detail.dialog.vue?vue&type=script&lang=js"
export * from "./detail.dialog.vue?vue&type=script&lang=js"
import style0 from "./detail.dialog.vue?vue&type=style&index=0&id=5f3c9cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c9cba",
  null
  
)

export default component.exports